import { APITypes } from '../../../primary-record-types';
import React from 'react';
import Stack from '../../v2BaseComponents/Stack';
import Text from '../../v2BaseComponents/Text';
import { getIntl } from '../../../utils/intl';
import SkeletonLoadingContainer from '../../v2BaseComponents/SkeletonLoadingContainer';

const intl = getIntl('SelectedProfilesHeader', {
    selectedProfile: 'Selected Profile: ',
    selectedProfiles: 'Selected Profiles: ',
});

export type Profile =
    | APITypes.medicalProfileService.ProfileListItem
    | APITypes.organizationService.OrganizationMedicalProfileDetails;

const isProfileListItem = (profile: Profile): profile is APITypes.medicalProfileService.ProfileListItem =>
    (profile as APITypes.organizationService.OrganizationMedicalProfileDetails).contactDetails === undefined;

export type SharedProfilesHeaderOwnProps = {
    selectedProfileIds: string[];
    profiles: Profile[];
    isLoadingProfiles: boolean;
};

export type SharedProfilesHeaderProps = SharedProfilesHeaderOwnProps;

const SharedProfilesHeader: React.FC<SharedProfilesHeaderProps> = ({
    selectedProfileIds,
    profiles,
    isLoadingProfiles,
}) => {
    const getNameForProfile = (profileId: string) => {
        if (isLoadingProfiles) return 'Placeholder'; // Placeholder rendered in skeleton

        const profile = profiles.find((_) => _.medicalProfileId === profileId);
        if (profile) {
            return isProfileListItem(profile)
                ? profile.preferredFirstName || profile.firstName
                : profile.contactDetails.preferredFirstName || profile.contactDetails.firstName;
        }

        return null;
    };

    return (
        <Stack horizontal fullWidth justify="flex-start" align="center" space={2}>
            <Text variant="h4">
                <Text variant="bold-h4">
                    {intl(selectedProfileIds.length > 1 ? 'selectedProfiles' : 'selectedProfile')}
                </Text>
                {selectedProfileIds.map((profileId, index) => (
                    <Stack horizontal key={profileId} align="flex-end">
                        <SkeletonLoadingContainer isLoading={isLoadingProfiles}>
                            <Text variant="h4">{`${getNameForProfile(profileId)}${
                                index < selectedProfileIds.length - 1 ? ', ' : ''
                            }`}</Text>
                        </SkeletonLoadingContainer>
                    </Stack>
                ))}
            </Text>
        </Stack>
    );
};

export default React.memo(SharedProfilesHeader);
